import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { DocumentsPageSize, DocumentsQueryFilters, fetchDocuments } from '~/api/documents';
import { useActiveCompanyId } from '~/hooks/useActiveCompany';
import { Document } from '~/types/document';
import { MetaDataCursorPage } from '~/types/jsonapi';

export const useDocumentsForTransactionRegistration = (filters: DocumentsQueryFilters) => {
  const companyId = useActiveCompanyId();

  return useInfiniteQuery({
    queryKey: ['Bookkeeping', 'documentsForTransactions', companyId, filters],
    queryFn: ({ pageParam }) =>
      fetchDocuments(companyId, filters, {
        cursor: pageParam,
        include: ['flows', 'flows.bookkeepingEntry', 'bookkeepingEntries', 'counterpart'],
      }),
    initialPageParam: '',
    placeholderData: keepPreviousData,
    getNextPageParam: ({ page: { cursor }, documents }: { page: MetaDataCursorPage; documents: Document[] }) => {
      if (documents.length >= DocumentsPageSize) {
        return cursor;
      }
      return undefined;
    },
  });
};
